/**
 * Catalog product names shared with
 * billing-core / offers. Leaf module (no imports) so any module — including
 * ones inside the plans ↔ medEligibility import cycle — can use these
 * without risking a cycle.
 */
export const BRANDED_SYNC_PRODUCT_NAME = "telehealth-medtier-branded";
export const BRANDED_ASYNC_PRODUCT_NAME = "telehealth-medtier-branded-async";

/**
 * Medication sale items on the medication selection page. Offers returns
 * these product names; dosage stays on the sale item, so one name covers
 * several dosages.
 */
export const WEGOVY_PILL_MICRODOSE_PRODUCT_NAME =
  "medication-wegovy-pill-microdose" as const;
export const WEGOVY_PILL_PRODUCT_NAME = "medication-wegovy-pill" as const;
export const WEGOVY_PEN_PRODUCT_NAME = "medication-wegovy-pen" as const;
export const ZEPBOUND_KWIKPEN_PRODUCT_NAME =
  "medication-zepbound-kwikpen-pen" as const;
export const FOUNDAYO_PILL_PRODUCT_NAME = "medication-foundayo-pill" as const;
export const COMPOUNDED_SEMAGLUTIDE_PRODUCT_NAME =
  "medication-compounded-semaglutide" as const;
export const COMPOUNDED_SEMAGLUTIDE_MICRODOSE_PRODUCT_NAME =
  "medication-compounded-microdose-semaglutide" as const;
export const COMPOUNDED_TIRZEPATIDE_PRODUCT_NAME =
  "medication-compounded-tirzepatide" as const;
export const COMPOUNDED_TIRZEPATIDE_MICRODOSE_PRODUCT_NAME =
  "medication-compounded-microdose-tirzepatide" as const;

/** Page order. The recommended product is sorted to the front at render time. */
export const MEDICATION_PRODUCT_NAMES = [
  WEGOVY_PILL_MICRODOSE_PRODUCT_NAME,
  WEGOVY_PILL_PRODUCT_NAME,
  WEGOVY_PEN_PRODUCT_NAME,
  ZEPBOUND_KWIKPEN_PRODUCT_NAME,
  FOUNDAYO_PILL_PRODUCT_NAME,
  COMPOUNDED_SEMAGLUTIDE_PRODUCT_NAME,
  COMPOUNDED_SEMAGLUTIDE_MICRODOSE_PRODUCT_NAME,
  COMPOUNDED_TIRZEPATIDE_PRODUCT_NAME,
  COMPOUNDED_TIRZEPATIDE_MICRODOSE_PRODUCT_NAME,
] as const;

export type MedProductName = (typeof MEDICATION_PRODUCT_NAMES)[number];

/** Compounded medications, the ones sold at an $80 discount. */
export const COMPOUNDED_MEDICATION_PRODUCT_NAMES = new Set<MedProductName>([
  COMPOUNDED_SEMAGLUTIDE_PRODUCT_NAME,
  COMPOUNDED_SEMAGLUTIDE_MICRODOSE_PRODUCT_NAME,
  COMPOUNDED_TIRZEPATIDE_PRODUCT_NAME,
  COMPOUNDED_TIRZEPATIDE_MICRODOSE_PRODUCT_NAME,
]);

export const DOSAGE_REQUIRED_PRODUCT_NAMES = new Set<MedProductName>([
  WEGOVY_PILL_MICRODOSE_PRODUCT_NAME,
  WEGOVY_PILL_PRODUCT_NAME,
  WEGOVY_PEN_PRODUCT_NAME,
  ZEPBOUND_KWIKPEN_PRODUCT_NAME,
  FOUNDAYO_PILL_PRODUCT_NAME,
]);

export const NON_SELLABLE_PRODUCT_NAMES = new Set<MedProductName>([
  ZEPBOUND_KWIKPEN_PRODUCT_NAME,
  FOUNDAYO_PILL_PRODUCT_NAME,
]);

export const MEMBERSHIP_PRODUCT_NAME = "telehealth-medtier-membership";
